import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowBoldUp = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 3L20 12.5V13H15V21H9V13H4V12.5L12 3Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconArrowBoldUp.js.map